/* eslint-disable */
export const languagesList = [
  // 'Deutsch',
  // 'Español',
  // 'Português',
  // '한국어',
  '中文',
  '日本語',
  'Français',
  // 'Svenska',
  // 'Bahasa Malaysia',
  // 'Pусский',
  // 'Nederlands',
  // 'Italiano',
  // 'Norsk',
  // 'Česky',
];

export const countryMapLanguage = {
  'Japan': '日本語',
  'France': 'Français',
  'China': '中文'
};
